module.exports = __webpack_public_path__ + "img/ndaylive_main.80819969.png";